'use client';

import { Button, Typography } from 'lighthouse';

import { withSeparator } from '@/utilities/withSeparator';

import { CAMPAIGN_DISCOUNT_AMOUNT } from '@/constants/batteryToBattery';

import classes from '../../index.module.css';
import Reveal from '../Reveal';

import { TicketDiscount } from 'iconsax-react';

interface FinalCtaProps {
    isLoggedIn: boolean;
    onCtaClick: () => void;
    onProductsClick: () => void;
}

const FinalCta = ({ isLoggedIn, onCtaClick, onProductsClick }: FinalCtaProps) => {
    return (
        <section className={classes.finalSection}>
            <div className='mx-auto flex w-full max-w-3xl flex-col items-center px-5 py-16 pb-28 text-center lg:py-24 lg:pb-24'>
                <Reveal>
                    <Typography variant='h4' component='h2' fontWeight={900} className='leading-[1.4] text-white'>
                        همین حالا ماشینت رو <span className='text-amber-300'>رایگان روشن کن.</span>
                    </Typography>
                    <Typography variant='body1' component='p' className='mx-auto mt-4 max-w-lg leading-8 text-white/70'>
                        باتری به باتری رایگان در محل + کد تخفیف {withSeparator(CAMPAIGN_DISCOUNT_AMOUNT)} تومان خرید باتری و لوازم یدکی جدید؛ فقط با
                        یک ثبت‌نام یک‌دقیقه‌ای.
                    </Typography>
                    <Button
                        size='large'
                        variant='contained'
                        onClick={isLoggedIn ? onProductsClick : onCtaClick}
                        endIcon={<TicketDiscount size={20} color='currentcolor' />}
                        className={`mt-8 bg-amber-400 font-extrabold text-[#0A1530] hover:bg-amber-300 ${classes.glowPulse}`}>
                        {isLoggedIn ? `خرید با ${withSeparator(CAMPAIGN_DISCOUNT_AMOUNT)} تومان تخفیف` : 'دریافت باتری به باتری رایگان'}
                    </Button>
                </Reveal>
            </div>
        </section>
    );
};

export default FinalCta;
